export default {
  label: {
    listening: {
      title: 'Filtro Não-proprietário',
      notClassified: 'Não Classificados',
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Tags',
    },
    sac: {
      title: 'Filtro Proprietário',
    },
    page: {
      title: 'Filtro de Páginas',
    },
    sacStatus: {
      title: 'Filtro de Atendimento',
      descriptionPart1: 'Os filtros do componente têm preferência sobre os globais. Observação: o filtro ',
      descriptionPart2: ' não sobrescreve o filtro global de status. O filtro ',
      descriptionPart3: ' sobrescreve o filtro global de status.',
      statusTransitionOld: 'Transição de status (antiga)',
      statusTransitionNew: 'Transição de status (nova)',
      statusTransitionCurrent: 'Transição de status (atual)',
    },
    comparative: {
      title: 'Filtro de Comparativo',
      notClassified: 'Não Classificados',
      groupsLabel: 'Grupos',
    },
    category: {
      title: 'Categoria',
      placeholder: 'Nenhum',
    },
    tagView: {
      title: 'Visualização de Tags',
      button_clear: 'Limpar Visualização',
    },
    sacListening: {
      title: 'Filtro Proprietário + Não-proprietários',
      listeningSession: 'Não-proprietários',
      sacSession: 'Proprietários',
      notClassified: 'Não Classificados',
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Tags',
    },
    sacFilter: {
      notClassified: 'Não Classificados',
      groups: 'Grupos',
      noGroups: 'Sem Grupos',
      themes: 'Temas',
      tags: 'Tags',
      repliers: 'Respondentes',
      status: 'Status',
    },
    blip: {
      title: 'Filtro Blip',
      channels: 'Canais',
      queues: 'Filas',
      attendants: 'Atendentes',
      tags: 'Tags',
      scheduling: 'Agendamento',
      campaignName: 'Nome da Campanha',
    },
    generic: {
      notClassified: 'Não Classificados',
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Tags',
    },
    button: {
      applyLabel: 'Aplicar',
      clearFilter: 'Limpar todo o filtro',
      clearchange: 'Reverter mudanças recentes',
    },
    dataTypeLabel: {
      listening: 'Dados não-proprietários',
      sac: 'Dados proprietários',
      page: 'Métricas das páginas',
      blip: 'BLIP',
      'sac-listening': 'Proprietários + Não Proprietários',
      custom: 'Personalizados',
      static: 'Complementares',
      'sac-status': 'Smart Care',
      filterPrefix: 'Filtro',
    },
  },
};
